// Import Vue
import Vue from 'vue'

import Vuex from 'vuex'

// Init Vuex
Vue.use(Vuex)

const LOGIN_USER = 'LOGGED_USER'
const LOGOUT_USER = 'LOGOUT_USER'

const store = new Vuex.Store({
  state: {
    isLoggedInUser: false,
    user: {
      username: '',
      picture: '',
      admin: false,
      auth: false
    },
    product: null,
    category: null
  },
  mutations: {
    [LOGIN_USER] (state) {
      state.isLoggedInUser = true
    },
    [LOGOUT_USER] (state) {
      state.isLoggedInUser = false
    }
  },
  actions: {
    loginUser ({
      commit
    }, user) {
      return new Promise((resolve, reject) => {
        this.state.user = user
        commit(LOGIN_USER)
        resolve()
      })
    },
    logoutUser ({
      commit
    }) {
      return new Promise((resolve, reject) => {
        this.state.user = null
        localStorage.clear()
        commit(LOGOUT_USER)
        resolve()
      })
    }
  },
  getters: {
    isLoggedInUser: state => {
      return state.isLoggedInUser
    },
    getUser: state => {
      return state.user
    },
    getProduct: state => {
      return state.product
    },
    getCategory: state => {
      return state.category
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store.js